export default __webpack_public_path__ + "static/gitkraken_main-3495f8473605f6a608c26a11f4565b64.png";